import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const saved = (() => {
  try {
    return localStorage.getItem('lang');
  } catch {
    return null;
  }
})();

i18n
  .use(initReactI18next)
  .init({
    lng: saved && ['en', 'fr', 'da', 'de'].includes(saved) ? saved : 'en',
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;